export default __webpack_public_path__ + "b43999f18047864704f365754034fc84.png";